import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageBanner({ title, subtitle, image, crumb }) {
  return (
    <section className="relative h-[42vh] min-h-[340px] w-full overflow-hidden flex items-center">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1f2c33]/70 via-[#1f2c33]/45 to-[#1f2c33]/70" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-10 w-full pt-16">
        <div className="flex items-center gap-2 mb-4 font-sans-ah tracking-wide-ah text-[12px] text-white/70">
          <Link to="/" className="hover:text-white">HOME</Link>
          <ChevronRight size={13} />
          <span className="text-white">{crumb || title}</span>
        </div>
        <h1 className="font-serif-ah text-white text-[46px] md:text-[64px] leading-none">{title}</h1>
        {subtitle && (
          <p className="font-sans-ah text-white/85 text-[16px] md:text-[18px] font-300 mt-4 max-w-[640px]">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
